import { render, staticRenderFns } from "./infoperusahaan.vue?vue&type=template&id=c8763586&scoped=true&"
import script from "./infoperusahaan.vue?vue&type=script&lang=js&"
export * from "./infoperusahaan.vue?vue&type=script&lang=js&"
import style0 from "./infoperusahaan.vue?vue&type=style&index=0&id=c8763586&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8763586",
  null
  
)

export default component.exports